import React, { memo } from 'react';
import { Social } from '../../interfaces/enums/Social';
import CustomLink from '../CustomLink/CustomLink';

interface SocialShareBtnProps {
  iconUrl: string;
  url: string;
  title?: string;
  summary?: string;
}

interface SocialShareBtnGeneratorProps {
  social: Social;
  url: string;
}

const SocialShareBtn: React.FC<SocialShareBtnProps> = ({
  iconUrl,
  url,
  title,
  summary,
}) => {
  return (
    <CustomLink
      url={url}
      label={title || 'social_media_platform'}
      className="border border-border/disabled rounded-full w-[40px] h-[40px] flex justify-center items-center group hover:bg-text/body transition-all"
    >
      <div className="h-[20px] w-[20px]">
        <div
          className="h-full w-full bg-no-repeat bg-text/body group-hover:bg-[white] transition-all block"
          style={{
            WebkitMaskImage: iconUrl,
            maskImage: iconUrl,
          }}
        />
      </div>
    </CustomLink>
  );
};
const SocialShareBtnGenerator: React.FC<SocialShareBtnGeneratorProps> = ({
  social,
  url,
}) => {
  switch (social) {
    case Social.FACEBOOK:
      return (
        <SocialShareBtn
          url={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          iconUrl="url('/svgs/facebook.svg')"
        />
      );
    case Social.LINKEDIN:
      return (
        <SocialShareBtn
          url={`https://www.linkedin.com/shareArticle?url=${url}`}
          iconUrl="url('/svgs/linkedin.svg')"
        />
      );
    case Social.TWITTER:
      return (
        <SocialShareBtn
          url={`http://twitter.com/share?url=${url}`}
          iconUrl="url('/svgs/twitter.svg')"
        />
      );
    case Social.EMAIL:
      return (
        <SocialShareBtn
          url={`mailto:body=${url}`}
          iconUrl="url('/svgs/email.svg')"
        />
      );
  }
};

export default memo(SocialShareBtnGenerator);
